import { HttpInterceptorFn } from '@angular/common/http';
import { analyticsHttpErrorInterceptor, requestCorrelationInterceptor } from '@lite-workspace/shared/services/analytics';
import { bearerInterceptor } from './bearer.interceptor';
import { clientPreviewFilesInterceptor } from './client-preview-files.interceptor';
import { errorInterceptor } from './error.interceptor';

// Клиент один не у всех: загрузкам нужен собственный XHR-клиент ради прогресса отправки. Цепочка
// живёт здесь, чтобы второй клиент не разъехался с приложением по авторизации и обработке ошибок.
// Корреляция — первой: analyticsHttpErrorInterceptor читает traceparent из запроса, каким тот к нему
// пришёл, поэтому позже она молча отдала бы пустой trace_id вместо id упавшего запроса.
export const APP_HTTP_INTERCEPTORS: HttpInterceptorFn[] = [
  requestCorrelationInterceptor,
  bearerInterceptor,
  errorInterceptor,
  analyticsHttpErrorInterceptor,
  clientPreviewFilesInterceptor,
];
